import React from 'react';
import { motion } from 'framer-motion';
export function BrandMoment() {
  return <section className="py-20 sm:py-32 md:py-48 px-4 sm:px-6 flex flex-col items-center justify-center relative" data-id="element-35">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 1.0,
      ease: 'easeOut'
    }} className="flex flex-col items-center" data-id="element-36">
        {/* Stylized P Monogram — matches brand kit submark */}
        <div className="relative w-28 h-28 sm:w-36 sm:h-36 md:w-48 md:h-48 mb-12 sm:mb-16" data-id="element-37">
          <svg viewBox="0 0 200 200" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-38">
            {/* Outer circle */}
            <circle cx="100" cy="100" r="88" stroke="#CFA060" strokeWidth="2" fill="none" data-id="element-39" />
            {/* Geometric P letterform — open bowl design */}
            <line x1="68" y1="50" x2="68" y2="150" stroke="#CFA060" strokeWidth="5" strokeLinecap="square" data-id="element-40" />
            <line x1="68" y1="50" x2="118" y2="50" stroke="#CFA060" strokeWidth="5" strokeLinecap="square" data-id="element-41" />
            <path d="M 118 50 Q 140 50 140 75 Q 140 100 118 100" stroke="#CFA060" strokeWidth="5" strokeLinecap="square" fill="none" data-id="element-42" />
            <line x1="118" y1="100" x2="68" y2="100" stroke="#CFA060" strokeWidth="5" strokeLinecap="square" data-id="element-43" />
          </svg>
        </div>

        {/* POLLOCK VENTURES wordmark */}
        <div className="flex flex-col items-center mb-10 sm:mb-14" data-id="element-44">
          <p className="font-heading text-sm sm:text-base tracking-[0.4em] uppercase text-brand-gold font-extralight mb-1" data-id="element-45">
            Pollock
          </p>
          <p className="font-heading text-[10px] sm:text-xs tracking-[0.5em] uppercase text-brand-gold font-light" data-id="element-46">
            Ventures
          </p>
        </div>

        {/* Thin gold divider */}
        <div className="w-16 h-px bg-brand-gold/40 mb-8 sm:mb-10" data-id="element-47" />

        {/* Brand essence pillars from brand kit */}
        <p className="font-heading text-[9px] sm:text-[10px] tracking-[0.3em] text-brand-warmGrey/70 uppercase text-center mb-6 sm:mb-8" data-id="element-48">
          Professional · Futuristic · Timeless · Built for what's next
        </p>

        <p className="font-heading text-[10px] sm:text-xs tracking-widest text-brand-warmGrey/40 uppercase" data-id="element-49">
          © 2026 Pollock Ventures
        </p>
      </motion.div>
    </section>;
}